import HalfPriceTraffic from "@components/HalfPriceTraffic";
import SEOHEAD from "@components/SEOHEAD";
import FloatScrollButton from "@components/ui/FloatScrollButton";
import AboutMe from "@components/ui/landing/AboutMe";
import Articles from "@components/ui/landing/Articles";
import Banner from "@components/ui/landing/Banner";
import Education from "@components/ui/landing/Education/Education";
import FreeCourses from "@components/ui/landing/FreeCourses";
import Icons from "@components/ui/landing/Icons";
import Introduction from "@components/ui/landing/Introduction";
import MainSlider from "@components/ui/landing/MainSlider";
import NewCourses from "@components/ui/landing/NewCourses";
import PreferCrourse from "@components/ui/landing/PreferCourse";
import SearchBar from "@components/ui/landing/searchBar";
import Teachers from "@components/ui/landing/Teachers";
import gate from "gate";
import { GetServerSideProps } from "next";
import React, { FC, useEffect, useState } from "react";
import { dehydrate, QueryClient, useQuery } from "react-query";

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();
  await queryClient.prefetchQuery(`home`, () => gate.home(), {
    staleTime: 1000 * 60 * 10,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

const Index: FC = () => {
  const [isDisplayable, setIsDisplayable] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const isHalfPriceTraffic = localStorage.getItem("isHalfPriceTraffic");
      if (isHalfPriceTraffic) {
        setIsDisplayable(false);
      } else {
        setIsDisplayable(true);
      }
    }
  }, []);
  const { data } = useQuery(`home`, () => gate.home(), {
    select: (data: any) => data?.data?.mainPage,
    refetchOnWindowFocus: false,
    onError: (err) => {
      console.log(err);
    },
    retry: 3,
  });

  return (
    <>
      <SEOHEAD
        {...{
          canonical: "",
          title: "دادبانان | آموزش حقوقی آنلاین، حقوق کاربردی و دوره‌های تخصصی وکالت",
          keyword: ["مؤسسه دادبانان"],
          seoDescription:
            "مؤسسه حقوقی دادبانان (دکتر فرهاد بیات)، مرکز آموزش‌های حقوقی کاربردی است که با تمرکز بر موضوعات مالی، اقتصادی و به ویژه حقوق کسب و کار در راستای شعار خویش (پیوند آموزش و اشتغال) گام بر می‌دارد.",
        }}
      />

      <div className="h-full bg-[#FAFAFC]">
        <div className="relative z-10 flex flex-col items-center">
          {isDisplayable && (
            <HalfPriceTraffic
              classes="w-full"
              type="HOME"
              spaces="mx-[4%] lg:mx-[10%]"
              text='هزینه اینترنت شما در سایت دادبانان، به صورت "نیم‌بها" محاسبه می‌شود.'
            />
          )}
          <SearchBar />

          <div className="pointer-events-none absolute z-0 h-auto w-full">
            <div className="relative h-full w-full grid-cols-1">
              <img
                fetchpriority="high"
                alt="background"
                src="images/backgrounds/blue.png"
              />
              <div className="flex w-full justify-end">
                <img
                  fetchpriority="high"
                  alt="background"
                  src="images/backgrounds/green.png"
                />
              </div>
              <img
                fetchpriority="high"
                alt="background"
                src="images/backgrounds/orange.png"
              />
              <div className="flex w-full justify-end">
                <img
                  fetchpriority="high"
                  alt="background"
                  src="images/backgrounds/purple.png"
                />
              </div>
            </div>
          </div>
          <div className="w-full space-y-8 md:space-y-16 lg:space-y-16 xl:space-y-36">
            <MainSlider
              categories={data?.categories}
              data={data?.slidersAndBanners?.first}
            />
            {data?.packages && <PreferCrourse data={data?.packages} />}
            {data?.slidersAndBanners && (
              <Education data={data?.slidersAndBanners?.sliders} />
            )}

            <div className="pr-[10%] md:px-[10%]">
              {data?.recentCourses && (
                <NewCourses
                  data={data?.recentCourses}
                  title="جدیدترین دوره‌ها"
                />
              )}
            </div>
            <Introduction />
            {data?.recentFreeCourses && (
              <FreeCourses data={data?.recentFreeCourses} />
            )}
            {data?.teachers && <Teachers data={data?.teachers} />}

            <Banner
              {...{
                countCourses: data?.countCourses,
                countStudents: data?.countStudents,
                banner: {
                  url: data?.slidersAndBanners?.last?.largeImage,
                  alt: data?.slidersAndBanners?.last?.largeImageText,
                },
                color: data?.slidersAndBanners?.last?.firstColor,
              }}
            />
            <AboutMe students={data?.adminStudents} />
            <Articles article={data?.recentArticles} />
            <Icons />
          </div>
        </div>
      </div>
      <FloatScrollButton />
    </>
  );
};
export default Index;
